import React, { useState } from 'react';
import { Badge, Button, Card, ProgressBar } from 'react-bootstrap';
import { FaEdit, FaRegCalendarAlt, FaSignal } from 'react-icons/fa';
import {
  MdHistory,
  MdInsertChart,
  MdInsertChartOutlined,
} from 'react-icons/md';
import { I18n } from 'react-redux-i18n'
import { TAB_LIST } from '../../../BillingUsage';
import { formatDateBilling } from './CreditGrants/CreditGrants';
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep';
import { CiBadgeDollar } from 'react-icons/ci';
import CCModal2025 from '../../../../../components/ccModal2025';
import { onBoardingGetFleetUsageCountApi } from '../../../../../constants/ApiConfigs';
import { callApiWithoutDispatch } from '../../../../../utils/apiUtils';
import moment from 'moment';
import {
  formatCurrencyHasSymbol,
  formatLongTypeToNumberCurrency,
} from '../../../../../utils/commonFunctions';
import { RiSpeedUpFill } from 'react-icons/ri';

const mappingKeyServiceType = (key) => {
  switch (key) {
    case 'flight_api':
      return 'flightAPI';
    case 'sms':
      return 'sms';
    case 'booking':
      return 'booking';
  }
};

const calculateUsagePercentage = (UsageCount, addOnsSettings, billingType) => {
  if (
    !UsageCount?.usageCount ||
    !addOnsSettings?.usageConfig?.[billingType]?.allowance
  ) {
    return 0;
  }
  return (
    (UsageCount?.usageCount /
      addOnsSettings?.usageConfig?.[billingType]?.allowance) *
    100
  ).toFixed(1);
};
const getvalueAddons = (addOns, billingUsage) => {
  return formatCurrencyHasSymbol(
    addOns?.pricingConfigs?.find(
      (item) => item.type === billingUsage?.billingType
    )?.fee,
    billingUsage.currencyISO
  );
};

export const handleAddOnFee = (addOns, billingUsage) => {
  const getOverageFee = (addOn) => {
    const fee = addOn?.usageConfig?.[billingUsage?.billingType]?.bookingTiers?.[0]
        ?.feeAmount || 0;
    if(!fee) {
      return ''
    }
    return formatCurrencyHasSymbol(fee, billingUsage.currencyISO);
  };
  const getPerRequest = (addOn) => {
    const allowance = addOn?.usageConfig?.[billingUsage?.billingType]?.allowance || 0;
    if(!allowance) {
      return ''
    }
    return allowance;
  };
  const addOnsFeeData =
    addOns?.pricingConfigs?.find(
      (item) => item.type === billingUsage?.billingType
    ) || {};
  let addOnsFee = [];
  if (addOnsFeeData.oneTimeFee) {
    addOnsFee.push({
      icon: <CiBadgeDollar />,
      text: `${I18n.t('billingUsage.oneTimeSetup')} ${addOnsFeeData.oneTimeFee ? formatCurrencyHasSymbol(
        addOnsFeeData.oneTimeFee,
        billingUsage.currencyISO
      ) : I18n.t('billingUsage.waived')}`,
    });
  }
  if (addOnsFeeData.fee) {
    addOnsFee.push({
      type: 'fee',
      icon: <FaRegCalendarAlt />,
      text: `${I18n.t('billingUsage.fee')} ${formatCurrencyHasSymbol(addOnsFeeData.fee, billingUsage.currencyISO)}/${
        billingUsage.billingType === BILLING_PLAN_TYPE.annual
          ? I18n.t('billingUsage.annual')
          : I18n.t('billingUsage.monthly')
      }`,
    });
  }
  if (getOverageFee(addOns)) {
    addOnsFee.push({
      icon: <CiBadgeDollar />,
      text: `${I18n.t('billingUsage.overage')} ${getOverageFee(addOns)} ${I18n.t('billingUsage.overagePerRequestText')}`,
    });
  }
  if (getPerRequest(addOns)) {
    addOnsFee.push({
      icon: <RiSpeedUpFill />,
      text: `${I18n.t('billingUsage.upToRequestsIncluded')} ${getPerRequest(addOns)} ${I18n.t('billingUsage.requestsIncluded')}`,
    });
  }
  return addOnsFee;
};

export default function AddOnsReview({
  billingUsage = {},
  onTabSelect,
  auth,
  loadingActions,
  notification,
}) {
  const handleEditAddOns = () => {
    onTabSelect(TAB_LIST.subscription);
  };
  const transformNewAddOns = () => {
    const getAddOnsFee = (addOn) => {
      return handleAddOnFee(addOn, billingUsage);
    };
    const addOnsAvailableSettings = billingUsage?.addOnsSettings
      ?.filter(
        (item) =>
          item.isActive === true &&
          billingUsage?.addOns.find((it) => it.id === item._id)
      )
      ?.map((item) => {
        const addOnsAdded = billingUsage?.addOns?.find(
          (i) => i.id === item._id
        );
        const addOn = {
          id: item._id,
          name: item.name,
          title: item.description,
          allowEmailBtn: item.allowEmailBtn,
          instructionUrl: item.instructionUrl,
          isChecked: addOnsAdded?.cancelAtPeriodEnd === false,
          cancelAtPeriodEnd: addOnsAdded?.cancelAtPeriodEnd,
          features: item.features,
          usageConfig: item.usageConfig,
          pricingConfigs: item.pricingConfigs,
          item: [...getAddOnsFee(item)],
          ...addOnsAdded,
        };
        return addOn;
      });
    return addOnsAvailableSettings;
  };
  const [isShowViewUsageModal, setIsShowViewUsageModal] = useState(false);
  const [itemViewUsage, setItemViewUsage] = useState(null);
  const [UsageCount, setUsageCount] = useState({});

  const handleViewUsage = async (item) => {
    try {
      loadingActions?.showLoadingSpiner();
      const response = await callApiWithoutDispatch(
        onBoardingGetFleetUsageCountApi,
        {
          method: 'POST',
          body: JSON.stringify({
            criteria: {
              fleetId: auth.selectedFleet.fleetId,
              startDate: moment(
                billingUsage?.subscription?.currentPeriodStart * 1000
              ).toISOString(),
              serviceType: mappingKeyServiceType(item.features[0]),
              timezone: auth.selectedFleet.timezone,
            },
            from: 0,
            size: 5,
            fleetId: auth.selectedFleet.fleetId,
          }),
          // 	body: JSON.stringify({
          // 		size: 20,
          // 		fleetId: 'migratecard',
          // 		criteria: {
          // 			timezone: 'Asia/Saigon',
          // 			startDate: '2025-03-01T07:10:00.350Z',
          // 			serviceType: 'flightAPI',
          // 		},
          // 	}),
        }
      );
      if (response?.res) {
        setUsageCount(response?.res);
        setItemViewUsage(item);
        setIsShowViewUsageModal(true);
      } else {
        notification('error', 'Failed to get usage');
      }
    } catch (error) {
      console.log('error', error);
      notification('error', 'Failed to get usage');
    } finally {
      loadingActions.hideLoadingSpiner();
    }
  };

  const handleCloseViewUsageModal = () => {
    setIsShowViewUsageModal(false);
    setUsageCount({});
    setItemViewUsage(null);
    setIsShowViewUsageModal(false);
  };
  const renderViewUsageModal = () => {
    const usagePercentage = calculateUsagePercentage(
      UsageCount,
      itemViewUsage,
      billingUsage?.billingType
    );
    return (
      <>
        {isShowViewUsageModal && (
          <CCModal2025
            title={
              <div className="usage-modal-title-container">
                <MdInsertChartOutlined
                  size={20}
                  style={{ marginRight: '5px', color: '#8b8b8b' }}
                />
                {I18n.t('billingUsage.usage')}
              </div>
            }
            isShow={true}
            onClose={handleCloseViewUsageModal}
            hideFooter={true}
            className="usage-modal-container"
            backdrop={true}
          >
            <div className="usage-modal-content">
              <h4>{itemViewUsage.name}</h4>
              <p className="usage-modal-description">{itemViewUsage.title}</p>
              <div className="usage-modal-usage-container">
                <div className="usage-modal-usage-container-item d-flex justify-content-between align-items-center">
                  <span>{I18n.t('billingUsage.usageThisCycle')}</span>
                  <span>{`${usagePercentage}%`}</span>
                </div>
                <ProgressBar
                  now={usagePercentage}
                  label={`${usagePercentage}%`}
                  color="#04BE76"
                />
                <span>
                  {`${UsageCount?.usageCount} of ${
                    itemViewUsage?.usageConfig?.[billingUsage?.billingType]
                      ?.allowance
                  } ${I18n.t('billingUsage.requests')}`}
                </span>
              </div>
              <div className="usage-modal-base-container">
                <div className="usage-modal-base-item">
                  <span className="usage-modal-base-item-title">{I18n.t('billingUsage.base')}</span>
                  <span className="usage-modal-base-item-value">
                    {`${getvalueAddons(itemViewUsage, billingUsage)}/${
                      billingUsage?.billingType === BILLING_PLAN_TYPE.annual
                        ? I18n.t('billingUsage.annual')
                        : I18n.t('billingUsage.monthly')
                    }`}
                  </span>
                </div>
                <div className="usage-modal-base-item">
                  <span className="usage-modal-base-item-title">{I18n.t('billingUsage.overage')}</span>
                  <span className="usage-modal-base-item-value">
                    {`${formatCurrencyHasSymbol(
                      formatLongTypeToNumberCurrency(
                        UsageCount.overage,
                        billingUsage.currencyISO
                      ),
                      billingUsage.currencyISO
                    )}`}
                  </span>
                </div>
              </div>
              <p className="mt-1" style={{ color: '#475467' }}>
                {`${getvalueAddons(itemViewUsage, billingUsage)} ${I18n.t('billingUsage.per')} ${
                  itemViewUsage?.usageConfig?.[billingUsage?.billingType]
                    ?.allowance
                } ${I18n.t('billingUsage.requests')}`}
              </p>
            </div>
          </CCModal2025>
        )}
      </>
    );
  };
  return (
    <div className="p-4 billing-table-container mt-4">
      {renderViewUsageModal()}
      <div className="table-header-billing d-flex justify-content-between align-items-center">
        <h4>{I18n.t('billingUsage.addOns')}</h4>
        <div className="d-flex align-items-center rightContent">
          <Button
            variant="link"
            className="billing-btn"
            style={{ padding: '5px 15px' }}
            onClick={handleEditAddOns}
          >
            <FaEdit size={12} className="mr-2" />
            {I18n.t('billingUsage.edit')}
          </Button>
        </div>
      </div>
      <div className="addons-section">
        <div className="addons-grid">
          {transformNewAddOns()?.map((item) => (
            <Card className="addon-card">
              <Card.Body>
                <div className="addon-content">
                  <div className="addon-type-container">
                    <span className="addon-type">{I18n.t('billingUsage.addOn')}</span>
                    {!item.allowEmailBtn && (
                      (item.features?.includes('sms') ||
                      item.features?.includes('flight_api')) &&
                      <Button
                        className="btn billing-btn btnViewUsage"
                        variant="link"
                        size="sm"
                        onClick={() => handleViewUsage(item)}
                      >
                        <FaSignal />
                        {I18n.t('billingUsage.viewUsage')}
                      </Button>
                    )}
                  </div>
                  <h4>{item.name}</h4>
                  <p style={{ whiteSpace: 'pre-line', color: 'rgba(203, 213, 225, 1)' }}>{item.title}</p>
                  {item.instructionUrl && (
                    <p style={{ marginBottom: '10px' }}>
                      <a style={{ fontSize: '14px', color: '#04BE76', textDecoration: 'none' }} href={item.instructionUrl} target="_blank" rel="noopener noreferrer">
                        {I18n.t('billingUsage.learnMore')}
                      </a>
                    </p>
                  )}
                  <div className="addon-usage">
                    {item?.item?.map((item, index) => (
                      <div className="add-on-item-content" key={index}>
                        <div className="add-on-item-text">
                          {item.icon}
                          <span style={{ marginLeft: '4px' }}>{item.text}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  {_.isBoolean(item.cancelAtPeriodEnd) && item?.item?.some(item => item.type === 'fee') &&
                    !item.allowEmailBtn && (
                      <p
                        className="add-on-item-content"
                        style={{ color: '#F04438', fontSize: '12px' }}
                      >
                        <span>
                          {I18n.t('billingUsage.endOfSubscription')}{' '}
                          {formatDateBilling(billingUsage.currentPeriodEnd)}
                        </span>
                      </p>
                    )}
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
